<div class="rules-container">
  <!-- <div>
  <mat-form-field>
    <mat-label>{{'RulesByExtensions.ExtensionsPlaceholder' | translate }}</mat-label>
    <mat-select [(ngModel)]="extensionSelected" (selectionChange)="onExtensionChange()">
      <mat-option *ngFor="let extension of extensions" [value]="extension">
        {{extension | extensionDisplay}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div> -->


<div class="action-zone">
  <!-- *ngIf="extensionSelected"  -->
  <button color="accent" mat-button routerLink="/extensionrule" [queryParams]="{extensionId: extension.id}">
    {{'RulesByExtensions.ButtonRuleCreation'|translate}}
    <mat-icon>add_circle</mat-icon>
  </button>
</div>

<div class="table-container">
  <form class="filters-form" [formGroup]="filtersForm">
    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" matSort>

        <!-- <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>
          <span mat-sort-header>{{'RulesByExtensions.ColumnHeaderId'|translate}}</span>
          <mat-form-field>
            <input matInput formControlName="id" (keyup)="applyFilters()" autocomplete="off"/>
            <button mat-icon-button matSuffix class="header-button" matTooltip="{{ 'RulesByExtensions.ResetFilterColumn' | translate }}"
              (click)="resetColumnFilter('id')" type="button">
              <mat-icon>undo</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
      </ng-container> -->

      <ng-container matColumnDef="enabled">
        <th mat-header-cell *matHeaderCellDef>
          <span mat-sort-header>{{'RulesByExtensions.ColumnHeaderEnabled'|translate}}</span>
          <div class="checkbox-header">
            <mat-checkbox color="accent" formControlName="enabled"
              [indeterminate]="checkBoxStatus === null" [checked]="checkBoxStatus"
            (change)="checkBoxChange()"></mat-checkbox>
            <button mat-icon-button matSuffix class="mat-accent search-icon"
              matTooltip="{{ 'RulesByExtensions.ResetFilterColumn' | translate }}"
              (click)="resetColumnFilter('enabled')">
              <mat-icon>undo</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox [checked]="element.enabled" disabled></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="extension">
        <th mat-header-cell *matHeaderCellDef>
          <span mat-sort-header>{{'RulesByExtensions.ColumnHeaderExtension'|translate}}</span>
          <div class="small">
            <mat-form-field class="form-field" appearance="outline">
              <input matInput formControlName="extension" (keyup)="applyFilters()"
                autocomplete="off" />
                <button mat-icon-button matSuffix class="mat-accent search-icon"
                  matTooltip="{{ 'RulesByExtensions.ResetFilterColumn' | translate }}"
                  (click)="resetColumnFilter('extension')">
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </th>
          <td mat-cell *matCellDef="let element"> {{element.extension | extensionDisplay}} </td>
        </ng-container>

        <ng-container matColumnDef="ringState">
          <th mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>{{'RulesByExtensions.ColumnHeaderRingState'|translate}}</span>
            <div class="small">
              <mat-form-field class="form-field" appearance="outline">
                <mat-select formControlName="ringState" (selectionChange)="applyFilters()" multiple>
                  @for (state of ringStates; track state) {
                    <mat-option [value]="state">
                      {{'EnumRingStates.' + state | translate}}
                    </mat-option>
                  }
                </mat-select>
                <button mat-icon-button matSuffix class="mat-accent search-icon"
                  matTooltip="{{ 'RulesByExtensions.ResetFilterColumn' | translate }}"
                  (click)="resetColumnFilter('ringState')">
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </th>
          <td mat-cell *matCellDef="let element"> {{'EnumRingStates.' + element.ringState | translate}}
          </td>
        </ng-container>

        <ng-container matColumnDef="targetType">
          <th mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>{{'RulesByExtensions.ColumnHeaderTargetType'|translate}}</span>
            <div class="small">
              <mat-form-field class="form-field" appearance="outline">
                <mat-select formControlName="targetType" (selectionChange)="applyFilters()"
                  multiple>
                  @for (targetType of ruleTargetTypes; track targetType) {
                    <mat-option [value]="targetType">
                      {{'EnumRuleTargetTypes.' + targetType | translate}}
                    </mat-option>
                  }
                </mat-select>
                <button mat-icon-button matSuffix class="mat-accent search-icon"
                  matTooltip="{{ 'RulesByExtensions.ResetFilterColumn' | translate }}"
                  (click)="resetColumnFilter('targetType')">
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </th>
          <td mat-cell *matCellDef="let element"> {{'EnumRuleTargetTypes.' + element.targetType |
          translate}} </td>
        </ng-container>

        <ng-container matColumnDef="ringSeconds">
          <th mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>{{'RulesByExtensions.ColumnHeadeRingSecond'|translate}}</span>
            <div class="small">
              <mat-form-field class="form-field" appearance="outline">
                <input matInput formControlName="ringSeconds" (keyup)="applyFilters()"
                  autocomplete="off" />
                  <button mat-icon-button matSuffix class="mat-accent search-icon"
                    matTooltip="{{ 'RulesByExtensions.ResetFilterColumn' | translate }}"
                    (click)="resetColumnFilter('ringSeconds')">
                    <mat-icon>undo</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let element"> {{element.ringSeconds}} </td>
          </ng-container>

          <ng-container matColumnDef="target">
            <th mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>{{'RulesByExtensions.ColumnHeadeTarget'|translate}}</span>
              <div class="small">
                <mat-form-field class="form-field" appearance="outline">
                  <input matInput formControlName="target" (keyup)="applyFilters()"
                    autocomplete="off" />
                    <button mat-icon-button matSuffix class="mat-accent search-icon"
                      matTooltip="{{ 'RulesByExtensions.ResetFilterColumn' | translate }}"
                      (click)="resetColumnFilter('target')">
                      <mat-icon>undo</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
              </th>
              <td mat-cell *matCellDef="let element"> {{element.targetDisplay}} </td>
            </ng-container>

            <ng-container matColumnDef="actions" stickyEnd>
              <th mat-header-cell *matHeaderCellDef>
                <button mat-icon-button matSuffix class="header-button"
                  matTooltip="{{ 'RulesByExtensions.ResetAllFiltersColumn' | translate }}"
                  (click)="resetAllColumnFilter()">
                  <mat-icon>undo</mat-icon>
                </button>
              </th>
              <td mat-cell *matCellDef="let element">
                <div class="action-column">
                  <button mat-icon-button routerLink="/extensionrule"
                    [queryParams]="{id: element.id, extensionId: element.extensionId}">
                    <mat-icon>visibility</mat-icon>
                  </button>
                  <button mat-icon-button (click)="onDeleteClick(element)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

          <mat-paginator [pageSizeOptions]="[25, 50, 100]" class="default-paginator"></mat-paginator>

        </div>
      </form>
    </div>
  </div>